import React from 'react';
import { RouteComponentProps } from 'react-router';
import PageLoader from 'components/page-loader';

export const Page = PageLoader({
	loader: () => import(/* webpackChunkName: "page-en-join-us" */ './main'),
});

export default (props: RouteComponentProps) => <Page {...props} />;
